import React from "react";

const Payables = ({ fillColor, strokeColor }) => {
  // const svgStyle = {
  //   fill: fillColor,
  //   stroke: strokeColor,
  //   strokeLinecap: "round",
  //   strokeLinejoin: "round",
  //   strokeWidth: "2px",
  // };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24.2 24.2"
      // style={svgStyle}
    >

    <path data-name="Path 41217" d="M235.715 153.71a12 12 0 1 0 8.485 3.515 12 12 0 0 0-8.485-3.515zm0 21.828a9.828 9.828 0 1 1 6.95-2.879 9.83 9.83 0 0 1-6.95 2.879z" transform="translate(-223.615 -153.61)" style={{fill:"#384853",stroke:"#fff",strokewidth:"4px"}}/>
    <path data-name="Path 41218" d="M309.57 213.606a1.086 1.086 0 0 0 0-2.172h-7.059a1.086 1.086 0 0 0 0 2.172h2.009a2.118 2.118 0 0 1 1.629 1.086h-3.638a1.086 1.086 0 0 0 0 2.172h3.638c-.38.543-.923.543-1.629.543h-2.009a1.087 1.087 0 0 0-.977.76 1.032 1.032 0 0 0 .217 1.194l5.05 4.778a1.033 1.033 0 0 0 .76.271.976.976 0 0 0 .76-.326 1.032 1.032 0 0 0 0-1.52l-3.15-2.824a4.834 4.834 0 0 0 3.312-2.878h1.087a1.086 1.086 0 0 0 0-2.172h-1.086a4.13 4.13 0 0 0-.326-1.086z" transform="translate(-293.941 -205.848)" style={{fill:"#384853",stroke:"#fff",strokewidth:"4px"}}/>


    </svg>
  );
};

export default Payables;
